import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLocation } from "react-router-dom";

const FloatingCTA = () => {
  const [show, setShow] = useState(false);
  const [formInView, setFormInView] = useState(false);
  const location = useLocation();
  const isBuilders = location.pathname.startsWith("/builders");
  const targetId = isBuilders ? "buy-box" : "offer-form";
  const label = isBuilders ? "Submit Your Buy Box" : "Get My Cash Offer";

  useEffect(() => {
    const onScroll = () => {
      setShow(window.scrollY > window.innerHeight * 0.7);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    // Reset detection whenever the route changes.
    setFormInView(false);
    const el = document.getElementById(targetId);
    if (!el || !("IntersectionObserver" in window)) return;
    const observer = new IntersectionObserver(
      ([entry]) => setFormInView(entry.isIntersecting),
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [targetId, location.pathname]);

  const visible = show && !formInView;

  const scrollToForm = () => {
    document
      .getElementById(targetId)
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="fixed bottom-5 left-1/2 -translate-x-1/2 z-40 md:hidden"
          data-testid="floating-mobile-cta"
        >
          <button
            onClick={scrollToForm}
            className="btn-primary flex items-center gap-2"
            style={{
              boxShadow: "0 20px 40px -12px rgba(18,43,32,0.55)",
            }}
          >
            <span>{label}</span>
            <ArrowRight size={16} strokeWidth={1.75} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingCTA;
